var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.76 17.75H10.23C9.12998 17.75 8.25998 17.21 7.76998 16.23L6.87998 14.44C6.66998 14.01 6.23998 13.75 5.75998 13.75H1.97998C1.56998 13.75 1.22998 13.41 1.22998 13C1.22998 12.59 1.56998 12.25 1.97998 12.25H5.76998C6.81998 12.25 7.75998 12.83 8.22998 13.77L9.11998 15.56C9.34998 16.02 9.71998 16.25 10.24 16.25H13.77C14.25 16.25 14.68 15.99 14.89 15.56L15.78 13.77C16.25 12.83 17.19 12.25 18.24 12.25H21.98C22.39 12.25 22.73 12.59 22.73 13C22.73 13.41 22.39 13.75 21.98 13.75H18.24C17.76 13.75 17.33 14.01 17.12 14.44L16.23 16.23C15.75 17.17 14.81 17.75 13.76 17.75Z",
    fill: "#8DC63F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.75C16.93 8.75 15.25 7.07 15.25 5C15.25 2.93 16.93 1.25 19 1.25C21.07 1.25 22.75 2.93 22.75 5C22.75 7.07 21.07 8.75 19 8.75ZM19 2.75C17.76 2.75 16.75 3.76 16.75 5C16.75 6.24 17.76 7.25 19 7.25C20.24 7.25 21.25 6.24 21.25 5C21.25 3.76 20.24 2.75 19 2.75Z",
    fill: "#8DC63F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H14C14.41 1.25 14.75 1.59 14.75 2C14.75 2.41 14.41 2.75 14 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V10C21.25 9.59 21.59 9.25 22 9.25C22.41 9.25 22.75 9.59 22.75 10V15C22.75 20.43 20.43 22.75 15 22.75Z",
    fill: "#8DC63F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectNotification);
export default __webpack_public_path__ + "static/media/DirectNotification.01ac8151a68d13ea96a3f8b26b52c48d.svg";
export { ForwardRef as ReactComponent };